/**
 * Textos da porta da apuração (ORD-F-153 e complemento de 20/10 20:40; DECISOES §84). **PARA APROVAR** pelo responsável,
 * com as capturas em 375 e 1366, antes e depois das 17h00 (pacotes/porta-login/LEIA.md). A porta é do site, não dos
 * números: nenhum texto diz que os dados são restritos (o feed continua público). Sem cadastro pelo site. Mensagens de
 * erro neutras: nunca dizem se o e-mail existe nem qual dos dois campos errou.
 */
import { interpolate } from './strings';

export const DOOR_STRINGS = {
  // a capa pública a partir das 17h00 de 25/10 (e com as fases desligadas)
  'door.kicker': 'Eleições 2026 · 2º turno',
  'door.title': 'A apuração do 2º turno é transmitida ao vivo no YouTube e no Instagram',
  'door.lede': 'Acompanhe os números do TSE com a nossa equipe, ao vivo:',
  'door.youtube': 'YouTube @mapa.voto.26',
  'door.youtube.aria': 'Canal do YouTube @mapa.voto.26 (abre em nova aba)',
  'door.instagram': 'Instagram @mapa.voto',
  'door.instagram.aria': 'Instagram @mapa.voto (abre em nova aba)',
  'door.social.aria': 'Onde assistir',
  'door.watch': 'Assistir ao vivo no YouTube',
  'door.watch.aria': 'Assistir ao vivo no YouTube (abre em nova aba)',
  'door.enter': 'Entrar e assistir no aplicativo',
  'door.links.aria': 'Mais do Mapa Voto',
  'door.links.polls': 'Pesquisas eleitorais',
  'door.links.replay': 'Replays das apurações',
  'door.links.videos': 'Vídeos',
  // 26/10, abertura pós-apuração: a capa e a porta no passado (a live ficou gravada no YouTube). PARA APROVAR
  'door.after.title': 'A apuração do 2º turno foi transmitida ao vivo no YouTube e no Instagram',
  'door.after.lede': 'A transmissão com a nossa equipe ficou gravada:',
  'door.after.watch': 'Assistir à transmissão no YouTube',
  'door.after.watch.aria': 'Assistir à transmissão no YouTube (abre em nova aba)',
  // o botão da página inicial e da pré-apuração (antes das 17h00)
  'door.cta': 'Ver ao vivo',
  'door.back': 'Voltar',
  // com sessão, antes das 17h00 (página inicial e pré-apuração)
  'door.session.note': 'Você entrou como {EMAIL}.',
  'door.signout': 'Sair',
  'door.signout.aria': 'Sair da conta {EMAIL}',
  // o formulário
  'login.title': 'Entrar',
  'login.lede': 'Para a equipe e os convidados do Mapa Voto. As contas são criadas pela equipe.',
  'login.email': 'E-mail',
  'login.password': 'Senha',
  'login.submit': 'Entrar',
  'login.submitting': 'Entrando…',
  'login.forgot': 'Esqueci a senha',
  'login.error.credentials': 'E-mail ou senha incorretos.',
  'login.error.empty': 'Preencha o e-mail e a senha.',
  'login.error.throttled': 'Muitas tentativas seguidas. Espere alguns minutos e tente de novo.',
  'login.error.network': 'Não foi possível entrar agora. Confira a conexão e tente de novo.',
  'login.error.config': 'O login ainda não está disponível neste site.',
  // "esqueci a senha"
  'reset.title': 'Esqueci a senha',
  'reset.lede': 'Digite o e-mail da sua conta. Se ele estiver cadastrado, enviamos um link para criar uma senha nova.',
  'reset.submit': 'Enviar o link',
  'reset.submitting': 'Enviando…',
  'reset.back': 'Voltar para entrar',
  'reset.sent':
    'Se o e-mail estiver cadastrado, você vai receber um link para criar uma senha nova. Confira também a caixa de spam.',
  'reset.error.empty': 'Digite o e-mail.',
  'reset.error.throttled': 'Muitos pedidos seguidos. Espere alguns minutos e tente de novo.',
  'reset.error.network': 'Não foi possível enviar agora. Confira a conexão e tente de novo.',
} as const;
export type DoorKey = keyof typeof DOOR_STRINGS;

export function tDoor(key: DoorKey, vars: Record<string, string | number> = {}): string {
  return interpolate(key, DOOR_STRINGS[key], vars);
}
